import './grnDetail.css';
import { formatDate, QrCodeDownload } from '../../../util/helper';
import { Button, Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { GetJWVendorDetails } from '../jw-grn/helper';
import QRCode from 'react-qr-code';

const GrnDetail = ({ isPrint, data, grnType }) => {
  const [vendorData, setVendorData] = useState([]);
  useEffect(() => {
    if (grnType === 'JW' && data.kitchenId) {
      GetJWVendorDetails(data.kitchenId).then((res) => {
        setVendorData(res);
      });
    }
  }, []);

  const getGrnUrl = () => {
    return window.location.origin + '/#/inv/grn/print/' + data?.id;
  };

  return (
    <div className={`grn-detail ${isPrint ? 'print-view me-5 ms-5' : ''}`}>
      <div className="text-center">
        <div className="mb-3">
          <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
          <h6 className="m-0" style={{ fontSize: '11px' }}>
            {data?.Branch?.name}
            <br />
            {data?.Branch?.address}
          </h6>
        </div>
        <div>
          <h5 className="mb-2">
            <b>
              <u>GOODS RECEIVED NOTE</u>
            </b>
          </h5>
        </div>
      </div>
      <Table bordered striped responsive className="mt-3">
        <tbody>
          <tr>
            <th>Name</th>
            <td>{data?.Kitchen?.name || data?.VendorMaster?.name || data?.supplierName}</td>
            <th>Address</th>
            <td>{data?.supplierAddress || data?.VendorMaster?.address || vendorData?.address}</td>
            <th>Supplier GST No.</th>
            <td>{data?.supplierGstin || data?.VendorMaster?.gst_num || vendorData?.gst_num}</td>
          </tr>
          <tr>
            <th>Invoice No.</th>
            <td>{data?.supplierInvoiceNumber ?? 'NA'}</td>
            <th>Invoice Date</th>
            <td>{data?.invoiceDate ? formatDate(data?.invoiceDate) : 'NA'}</td>
            <th>PO No.</th>
            <td>{data?.poNumber ?? 'NA'}</td>
          </tr>
          <tr>
            <th>PO Date</th>
            <td>{data?.poDate ? formatDate(data?.poDate) : 'NA'}</td>
            <th>GRN No.</th>
            <td>{data?.grnNumber ?? 'NA'}</td>
            <th>GRN Date</th>
            <td>{data?.grnDate ? formatDate(data?.grnDate) : 'NA'}</td>
          </tr>
          <tr>
            <th>DC No.</th>
            <td>{data?.dcNumber ?? 'NA'}</td>
            <th>DC Date</th>
            <td>{data?.dcDate ? formatDate(data?.dcDate) : 'NA'}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered className="text-center grn-detail-table">
        <thead>
          <tr>
            <th className="p-0.5">Sl No.</th>
            <th className="p-05">Item Name</th>
            <th className="p-05">HSN Code</th>
            <th className="p-05">Unit</th>
            {!isPrint && <th className="p-05">Description</th>}

            <th className="p-05">Qty As per Invoice</th>
            <th className="p-05">Qty Received</th>
            {!isPrint && (
              <>
                <th className="trp-5">Rate Per Unit</th>
                <th className="trp-5">CGST</th>
                <th className="trp-5">SGST</th>
                <th className="trp-5">IGST</th>
                <th className="trp-5">Invoice Amount</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data?.assetsInfo?.map((item, index) => {
            return (
              <tr key={index}>
                <td className="p-05">{index + 1}</td>
                <td className="p-05">{item?.itemName}</td>
                <td className="p-05">{item?.hsnCode}</td>
                <td className="p-05">{item?.unit}</td>
                {!isPrint && <td className="trp-5">{item?.description}</td>}
                <td className="p-05">{item?.quantityAsPerInvoice}</td>
                <td className="p-05">{item?.quantityReceived}</td>
                {!isPrint && (
                  <>
                    <td className="trp-5">{item?.rate}</td>
                    <td className="trp-5">{item?.cgst}</td>
                    <td className="trp-5">{item?.sgst}</td>
                    <td className="trp-5">{item?.igst}</td>
                    <td className="trp-5">{item?.invoiceAmount}</td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
      {!isPrint && (
        <Table style={{ width: '100%', marginTop: '20px' }}>
          {data?.assetsInfo?.map((item, index) => {
            return (
              <tbody style={{ marginTop: '10px' }}>
                <tr key={index}>
                  {item.quantityRejected > 0 && (
                    <td width="100%">
                      Item <span className="fw-bold">{item.itemName}</span>, quantity as per invoice is{' '}
                      <span className="fw-bold">{item.quantityAsPerInvoice}</span> (<span className="fw-bold">{item.unit}</span>) but
                      quantity received is <span className="fw-bold">{item.quantityReceived}</span> (
                      <span className="fw-bold">{item.unit}</span>). Hence the total rejected quantity is{' '}
                      <span className="fw-bold">{item.quantityRejected}</span> (<span className="fw-bold">{item.unit}</span>). Remarks for
                      rejection is <span className="fw-bold">{item.remarksForRejection}</span>
                    </td>
                  )}
                </tr>
              </tbody>
            );
          })}
        </Table>
      )}

      {isPrint && (
        <Table style={{ width: '100%', marginTop: '60px' }}>
          <tfoot>
            <tr>
              <td width="33.33%">
                <h6>Prepared by</h6>
              </td>
              <td width="33.33%" align="center">
                <h6>Stores Incharge</h6>
              </td>
              <td width="33.33%" align="right">
                <h6>Authorised Signatory/Manager</h6>
              </td>
            </tr>
          </tfoot>
        </Table>
      )}

      {!isPrint && (
        <div className="total-amount">
          <p>
            <span>Charge Type ({data?.chargeType ?? 'NA'})</span>
            <span>{data?.chargeAmount}</span>
          </p>
          <p style={{ fontWeight: 'bold' }}>
            <span>Total Amount</span>
            <span style={{ marginLeft: '35px' }}>{data?.totalAmount}</span>
          </p>
          {!grnType && grnType !== 'JW' && (
            <Button
              href={`#/inv/grn/print/${data.id}`}
              target="_blank"
              rel="noreferrer"
              style={{
                backgroundColor: '#4CAF50',
                borderRadius: '12px',
                marginLeft: '27rem',
              }}
            >
              Go to PDF
            </Button>
          )}
        </div>
      )}
      {!isPrint && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <div style={{ textAlign: 'center' }}>
            <p style={{ margin: '0', fontSize: '12px' }}>
              <b>{data?.grnNumber}</b>
            </p>
            <div style={{ background: 'white', padding: '8px', margin: '8px 0' }}>
              <QRCode
                id="grn-qr-code"
                value={getGrnUrl()}
                size={100}
                level="H"
                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              />
            </div>
            <p style={{ margin: '0', fontSize: '12px' }}>{data?.Kitchen?.name || data?.VendorMaster?.name || data?.supplierName}</p>
            <button onClick={() => QrCodeDownload("grn-qr-code", data?.grnNumber, data?.Kitchen?.name || data?.VendorMaster?.name || data?.supplierName)} className="btn btn-sm btn-secondary mt-2" style={{ fontSize: '12px' }}>
              Download QR
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrnDetail;
